/** Standalone emoji messages get a larger, frameless treatment in chat. A
 * grapheme is one visible symbol, so flags and joined family emoji count as
 * one instead of being split into their underlying Unicode code points. */
const emojiStart = /^(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[0-9#*]\uFE0F?\u20E3)/u;
const segmenter = typeof Intl.Segmenter === 'function'
  ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
  : null;

export function standaloneEmojiCount(content: string): number {
  const text = content.trim();
  if (!text || text.length > 96) return 0;
  const graphemes = (segmenter
    ? Array.from(segmenter.segment(text), ({ segment }) => segment)
    : Array.from(text))
    .filter((segment) => !/^\s+$/u.test(segment));
  if (graphemes.length < 1 || graphemes.length > 3) return 0;
  return graphemes.every((segment) => emojiStart.test(segment)) ? graphemes.length : 0;
}
